import React, { useEffect, useState } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { ICON_EYE_FILL, ICON_PLUS } from "../../../utils/icons";
import { Button, TableContainer } from "../../../styles";
import MiniLoader from "../../../utils/MIniLoader";
import { useNavigate } from "react-router-dom";
import { useWaybillContext } from "../../../context/waybill_context";
import CustomTable from "../../../utils/CustomTable";

export default function AllWaybill() {


  const [waybillId, setWaybillId] = useState('');
  const navigate = useNavigate();

  const {
    waybillLoading, waybillData, getWaybillData,
  } = useWaybillContext();

  useEffect(() => {
    getWaybillData();
  }, []);

  const doWaybill = (item) => {
    setWaybillId(item?.token);
    navigate(`/user/waybill/${ item?.invid }`,
      { state: { obj: 'this' } }
    );
  };

  useEffect(() => {
    const waybill = waybillData?.map((item, i) => {
      const { id, real_date, invid, driverName, driverNumber, vehicleNumber, rName, rNumber } = item;
      return (
        {
          sm: i + 1,
          id,
          real_date,
          invid,
          driverName,
          driverNumber,
          vehicleNumber,
          rName,
          rNumber,
          action:
            <h6 className="d-flex fit-content border-bottom pointer border-primary pry-text text-center"
              onClick={() => doWaybill(item)}
            >
              {ICON_EYE_FILL} View
            </h6>

        }
      );
    }).reverse();

    setDatatable({
      ...datatable,
      rows:
        waybill
    });
  }, [waybillData]);
  //  Get All waybill


  const [datatable, setDatatable] = React.useState({
    columns: [
      {
        label: "S/N",
        field: "sn",
        width: 150,
      },
      {
        label: "ID",
        field: "id",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Id",
        },
      },
      {
        label: "Date",
        field: "real_date",
        width: 200,
      },
      {
        label: "Invoice ID",
        field: "invid",
        width: 200,
      },
      {
        label: "Driver's Name",
        field: "driverName",
        width: 200,
      },
      {
        label: "Driver's Number",
        field: "driverNumber",
        width: 200,
      },
      {
        label: "Vehicle's Number",
        field: "vehicleNumber",
        width: 200,
      },
      {
        label: "Receiver's Name",
        field: "rName",
        width: 200,
      },
      {
        label: "Receiver's Number",
        field: "rNumber",
        width: 200,
      },
      {
        label: "Action",
        field: "action",
        width: 200,
      }

    ],
    rows: []
  });

  return (
    <>

      <div className="">

        <CustomTable
          tableTitle={"All Waybill"}
          loading={waybillLoading}
          getData={getWaybillData}
          datatable={datatable}
        />

      </div>


      {/* Invoice Reciept */}
      <div className="mt-5">
        <iframe src={`/waybill/${ waybillId }`} name="frame2" className="d-none w-100"></iframe>
      </div>
      {/* Invoice Reciept */}
    </>

  );
}
